import { useEffect, useState } from "react";
import {
  getFinFoxRunnerEnabled,
  setFinFoxRunnerEnabled,
  subscribeFinFoxRunner,
} from "@/lib/finfoxPrefs";

/** Shared React binding for the FinFox header runner preference. */
export function useFinFoxRunner() {
  const [enabled, setEnabled] = useState(getFinFoxRunnerEnabled);

  useEffect(() => subscribeFinFoxRunner(setEnabled), []);

  return {
    enabled,
    setEnabled: (on: boolean) => {
      setFinFoxRunnerEnabled(on);
      setEnabled(on);
    },
    toggle: () => {
      const next = !enabled;
      setFinFoxRunnerEnabled(next);
      setEnabled(next);
    },
  };
}
